import { CSSProperties, memo, ReactElement, ReactNode } from "react";
import { Form, FormField, FormGroup, Header, Modal, ModalActions } from "semantic-ui-react";
// Commons
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";

// Type
export type ModMeFormProps = {
  // Func
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;

  // detail
  header: ReactNode;
  content: ReactNode;
  confirmTitle?: string | ReactElement;
  cancelTitle?: string | ReactElement;

  // config
  isOneButton?: boolean;
  confirmBtnStyle?: CSSProperties;
  cancelBtnStyle?: CSSProperties;
};

const ModMeForm = (props: ModMeFormProps) => {
  return (
    <Modal open={props.open} onClose={props.onClose} size="tiny">
      <div style={{ margin: "1rem" }}>
        <Header dividing>{props.header || "ModMeForm Header"}</Header>

        {props.content || <div>ModMeForm Content</div>}
      </div>

      <Form style={{ marginTop: "2rem" }}>
        {props.isOneButton ? (
          <FormGroup inline style={{ margin: 0 }}>
            <FormField width={16} style={{ padding: 0 }}>
              <ButtonLoadCheck
                style={{ borderRadius: 0, ...props.cancelBtnStyle }}
                fluid
                title={props.cancelTitle ?? "Close"}
                color="grey"
                onClick={props.onClose}
              />
            </FormField>
          </FormGroup>
        ) : (
          <FormGroup inline style={{ margin: 0 }}>
            <FormField width={8} style={{ padding: 0 }}>
              <ButtonLoadCheck
                style={{ borderRadius: 0, ...props.cancelBtnStyle }}
                fluid
                title={props.cancelTitle ?? "Cancel"}
                color="grey"
                onClick={props.onClose}
              />
            </FormField>
            <FormField width={8} style={{ padding: 0 }}>
              <ButtonLoadCheck
                style={{
                  borderRadius: 0,
                  backgroundColor: "var(--primary-theme-color)",
                  color: "white",
                  ...props.confirmBtnStyle
                }}
                fluid
                title={props.confirmTitle ?? "Confirm"}
                onClick={props.onConfirm}
              />
            </FormField>
          </FormGroup>
        )}
      </Form>
    </Modal>
  );
};

ModMeForm.displayName = "ModMeForm";

export default memo(ModMeForm);
